<template>
    <div class="card">
        <div class="card-body">
            <form class="row" @submit.prevent="submitChangeMyPassword">
                <form-input
                    v-for="formInput in formInputs"
                    :key="formInput.property"
                    v-model="passwords[formInput.property]"
                    v-bind="formInput"
                    :error-message="getError(formInput.property)"
                />
                <div class="col-12">
                    <button
                        type="submit"
                        class="btn btn-success waves-effect waves-light"
                    >
                        Save
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { StatusCodes as HTTP } from 'http-status-codes';
import { required, sameAs, minLength } from 'vuelidate/lib/validators';

export default {
    validations: {
        passwords: {
            currentPassword: { required },
            password: {
                required,
                minLength: minLength(6),
                containsDigit: v => {
                    return /\d/.test(v);
                }
            },
            passwordConfirmation: {
                required,
                sameAsPassword: sameAs('password')
            }
        }
    },

    data() {
        return {
            passwords: {},
            serverErrors: [],
            formInputs: [
                {
                    property: 'currentPassword',
                    label: 'Current Password',
                    type: 'password'
                },
                {
                    property: 'password',
                    label: 'Password',
                    type: 'password'
                },
                {
                    property: 'passwordConfirmation',
                    label: 'Password Confirmation',
                    type: 'password'
                }
            ]
        };
    },

    methods: {
        ...mapActions({
            changePassword: 'auth/changePassword'
        }),

        async submitChangeMyPassword() {
            this.serverErrors = [];

            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            }

            try {
                await this.changePassword(this.passwords);

                this.passwords = {};
                this.$v.$reset();

                this.$toaster('Password has been changed!');
            } catch (error) {
                const { response } = error;

                if (response) {
                    const { data, status } = response;

                    if (status === HTTP.BAD_REQUEST && data.errors) {
                        this.serverErrors = data.errors;

                        this.$toasterError('Recheck your form.');

                        return;
                    }

                    if (status === HTTP.UNPROCESSABLE_ENTITY && data) {
                        this.$toasterError(data);

                        return;
                    }
                }

                console.error(error);

                this.$toasterError();
            }
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.$v.passwords,
                this.serverErrors,
                key
            );
        }
    }
};
</script>
